import type { IEmailSubscriptions, ISimpleEventDictionary } from '@model/userFullProfile';

export const getSimpleEmailSubscriptions = (
  simpleEvents?: Array<ISimpleEventDictionary>,
  emailSubscriptions?: IEmailSubscriptions,
) => {
  const events: { [key: number]: boolean } = {};
  const emailSubscriptionsIds: { [key: number]: boolean } = {};

  Object.values(emailSubscriptions || {}).forEach((item) => {
    if (item.event?.id) {
      emailSubscriptionsIds[item.event.id] = true;
    }
  });

  simpleEvents?.forEach((event) => {
    const eventName = event.name?.toLowerCase();

    if (eventName.includes('reminder') || eventName.includes('deactivate')) {
      events[event.id] = !emailSubscriptions || emailSubscriptionsIds[event.id] ? true : false;
    }
  });

  return events;
};
